import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ProtectedProfilesTable } from './components/index.js';
import {
  getVariables,
  instructionTypeForFilter,
  queryParamsInitial,
  setSearchParamsToState,
} from './store/index.js';

import { useDidMountEffect } from '@hooks';

import {
  getFiltersFromSearchParams,
  setFilterParamsToSearchParams,
  setSortParamsToSearchParams,
} from '@/utils';
import { Box } from '@/elements';
import { useLazyQuery } from '@apollo/client';
import { GET_L3_PROTECTED_PROFILES } from '@/common/actions/get';
import { SubNavigation } from '@/common/pages/networkProtectionV2/components/SubNavigation/index.jsx';

const ProtectedProfilesView = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [queryParams, setQueryParams] = useState({
    ...queryParamsInitial,
    filters: getFiltersFromSearchParams(Object.fromEntries([...searchParams])),
  });

  const [getL3ProtectedProfiles, { data: l3ProtectedProfilesData, l3ProtectedProfilesLoading }] =
    useLazyQuery(GET_L3_PROTECTED_PROFILES, {});

  const onPageChange = (page, size) => {
    searchParams.set('page', String(page));
    searchParams.set('pageSize', String(size));

    setSearchParams(searchParams, { replace: true });
  };

  const onSortingChange = (sortArray) => {
    searchParams.set('page', String(queryParamsInitial.page));

    setSortParamsToSearchParams(sortArray, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  const onFiltersChange = (filterList) => {
    searchParams.set('page', String(queryParamsInitial.page));

    setFilterParamsToSearchParams(filterList, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, queryParamsInitial);
  }, [searchParams]);

  useDidMountEffect(() => {
    let variables = getVariables(queryParams, instructionTypeForFilter);

    getL3ProtectedProfiles({ variables });
  }, [queryParams]);

  return (
    <>
      <Box>
        <SubNavigation />
      </Box>

      <Box direction="column" padding="35px" gap="30px">
        <ProtectedProfilesTable
          loading={l3ProtectedProfilesLoading}
          data={l3ProtectedProfilesData?.l3ProtectedProfiles?.items || []}
          onPageChange={onPageChange}
          onSortingChange={onSortingChange}
          onFiltersChange={onFiltersChange}
          queryParams={queryParams}
          totalPages={l3ProtectedProfilesData?.l3ProtectedProfiles?.info?.totalPages || 1}
          totalCount={l3ProtectedProfilesData?.l3ProtectedProfiles?.info?.totalCount || 0}
        />
      </Box>
    </>
  );
};

export default ProtectedProfilesView;
